import React from 'react';

import './VideoFrame.css';

const VideoFrame = ({ url, title }) => (
    <div className="video-frame">
        <iframe className="video-frame__iframe" src={url} title={title} />
    </div>
);

export default VideoFrame;
